import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal, Vertical } from 'atoms/layout/flex';
import { LinkBox } from 'atoms/navigation/Box';
import { LabelM } from 'atoms/typography';
import { Box } from 'atoms/ui/Box';
import { glossary } from 'lib/glossary';
import { tabletAndAbove } from 'style/mediaQuery';

const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
`;
const Header = styled(Horizontal)`
  background-color: var(--c-neutral-300);
  padding: var(--intermediate-unit) var(--double-unit);
`;
const MainContent = styled(Vertical).attrs({ center: true })`
  padding: var(--intermediate-unit) var(--double-unit) var(--double-unit);
`;
const CtaWrapper = styled.div`
  @media ${tabletAndAbove} {
    align-self: center;
  }
`;

type Props = {
  avatar: ReactNode;
  cta: ReactNode;
  children: ReactNode;
};

export const PlayLineupBox = ({ avatar, cta, children }: Props) => {
  return (
    <Wrapper>
      <Header gap={1}>
        {avatar}
        <LabelM as="span" bold>
          <FormattedMessage {...glossary.you} />
        </LabelM>
      </Header>
      <LinkBox>
        <MainContent gap={1.5}>
          {children}
          <CtaWrapper>{cta}</CtaWrapper>
        </MainContent>
      </LinkBox>
    </Wrapper>
  );
};
